import {
  getClientByBrick,
  getPhaseById,
  isPhaseEntry,
  isProjectEntry,
  phaseIdFromEntry,
  projectIdFromEntry,
} from '../../../utils/phases';
import { mergeContiguousSegments, packLanes } from '../../../utils/planning';
import { findBrick } from '../shared/assignmentTarget';
import { plannedHours, windowIndexes } from '../shared/lanes';

// Client visé par une affectation (brique, phase entière ou, ancien format, projet entier).
export function clientIdOfAff(clients, aff) {
  if (isPhaseEntry(aff.briqueId))
    return getPhaseById(clients, phaseIdFromEntry(aff.briqueId))?.client?.id || null;
  if (isProjectEntry(aff.briqueId)) return projectIdFromEntry(aff.briqueId);
  return getClientByBrick(clients, aff.briqueId)?.client?.id || null;
}

// Libellé de brique d'une affectation, et la brique elle-même quand l'affectation en vise une.
function brickOf(a, client) {
  if (isPhaseEntry(a.briqueId)) {
    const ph = (client.phases || []).find((p) => p.id === phaseIdFromEntry(a.briqueId));
    return { brick: null, label: ph ? `${ph.nom} (général)` : null };
  }
  if (isProjectEntry(a.briqueId)) return { brick: null, label: null };
  const brick = findBrick(client, a.briqueId);
  return { brick, label: brick?.nom || (brick ? brick.nom : null) };
}

/* Barres d'une phase (fusion des allocations contiguës + couloirs), avec la consommation Jira de
   l'epic de la brique quand elle en a un. */
export function projectSegments({ affs, client, appState, jiraData, firstIso, lastIso }) {
  const raw = affs.map((a) => {
    const { brick, label } = brickOf(a, client);
    const { h, totalH } = plannedHours(appState.devs, a);
    const consoJira = brick?.jira_epic ? (jiraData.byEpic?.[brick.jira_epic] ?? null) : null;
    return {
      affId: a.id,
      devId: a.devId,
      briqueId: a.briqueId,
      ...windowIndexes(a, firstIso, lastIso),
      h,
      totalH,
      brique: label,
      consoJira: consoJira != null ? Math.round(consoJira * 10) / 10 : null,
      realStart: a.debut,
      realEnd: a.fin,
    };
  });
  const segs = mergeContiguousSegments(raw, (r) => `${r.devId}|${r.briqueId}|${r.h}`);
  return packLanes(segs);
}
